/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchDeleteDimensionDto,
  CreateDimensionDto,
  CreateDimensionMappingRequest,
  DeleteDimensionMappingRequest,
  DimensionDto,
  UpdateDimensionDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DimensionController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags dimension-controller
   * @name GetAccountingPlatformDimensions
   * @request GET:/api/v1/dimension
   */
  getAccountingPlatformDimensions = (params: RequestParams = {}) =>
    this.http.request<DimensionDto[], any>({
      path: `/v1/dimension`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountingPlatformDimensionsPath = '/v1/dimension'
  static getAccountingPlatformDimensionsMethod = 'GET'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name UpdateDimension
   * @request PUT:/api/v1/dimension
   */
  updateDimension = (data: UpdateDimensionDto, params: RequestParams = {}) =>
    this.http.request<DimensionDto, any>({
      path: `/v1/dimension`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDimensionPath = '/v1/dimension'
  static updateDimensionMethod = 'PUT'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name CreateDimension
   * @request POST:/api/v1/dimension
   */
  createDimension = (data: CreateDimensionDto, params: RequestParams = {}) =>
    this.http.request<DimensionDto, any>({
      path: `/v1/dimension`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDimensionPath = '/v1/dimension'
  static createDimensionMethod = 'POST'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name BatchDeleteDimension
   * @request DELETE:/api/v1/dimension
   */
  batchDeleteDimension = (data: BatchDeleteDimensionDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/dimension`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchDeleteDimensionPath = '/v1/dimension'
  static batchDeleteDimensionMethod = 'DELETE'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name CreateOrUpdateSubTransactionDimensionMapping
   * @request POST:/api/v1/dimension/transactions/{flowId}/sub-transactions/{subTransactionId}/mapping
   */
  createOrUpdateSubTransactionDimensionMapping = (
    flowId: string,
    subTransactionId: string,
    data: CreateDimensionMappingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/dimension/transactions/${flowId}/sub-transactions/${subTransactionId}/mapping`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static createOrUpdateSubTransactionDimensionMappingPath =
    '/v1/dimension/transactions/${flowId}/sub-transactions/${subTransactionId}/mapping'
  static createOrUpdateSubTransactionDimensionMappingMethod = 'POST'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name CreateOrUpdateTransactionDimensionMapping
   * @request POST:/api/v1/dimension/transactions/{flowId}/mapping
   */
  createOrUpdateTransactionDimensionMapping = (
    flowId: string,
    data: CreateDimensionMappingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/dimension/transactions/${flowId}/mapping`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static createOrUpdateTransactionDimensionMappingPath =
    '/v1/dimension/transactions/${flowId}/mapping'
  static createOrUpdateTransactionDimensionMappingMethod = 'POST'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name DeleteSubTransactionDimensionMapping
   * @request DELETE:/api/v1/dimension/transactions/{flowId}/sub-transactions/{subTransactionId}/mapping/{dimensionId}
   */
  deleteSubTransactionDimensionMapping = (
    flowId: string,
    subTransactionId: string,
    dimensionId: string,
    data: DeleteDimensionMappingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/dimension/transactions/${flowId}/sub-transactions/${subTransactionId}/mapping/${dimensionId}`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deleteSubTransactionDimensionMappingPath =
    '/v1/dimension/transactions/${flowId}/sub-transactions/${subTransactionId}/mapping/${dimensionId}'
  static deleteSubTransactionDimensionMappingMethod = 'DELETE'
  /**
   * No description
   *
   * @tags dimension-controller
   * @name DeleteTransactionDimensionMapping
   * @request DELETE:/api/v1/dimension/transactions/{flowId}/mapping/{dimensionId}
   */
  deleteTransactionDimensionMapping = (
    flowId: string,
    dimensionId: string,
    data: DeleteDimensionMappingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/dimension/transactions/${flowId}/mapping/${dimensionId}`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deleteTransactionDimensionMappingPath =
    '/v1/dimension/transactions/${flowId}/mapping/${dimensionId}'
  static deleteTransactionDimensionMappingMethod = 'DELETE'
}
